const Home = {
  'pages_dashboard.title': '대시보드',
  'pages_dashboard_opsnow_service.title': 'OpsNow 서비스',
  'pages_dashboard_opsnow_service.detail': '다양한 OpsNow 서비스를 통해 효율적인 Cloud를 사용하세요.',
  'pages_dashboard_opsnow_service.request': '서비스 신청',
  'pages_dashboard_opsnow_service.title_1': 'FinOps',
  'pages_dashboard_opsnow_service.title_2': 'HelpNow AI',
  'pages_dashboard_opsnow_service.title_3': 'AlertNow',

  'pages_dashboard_before_month_total_used_amount.title': '전월 총 사용 비용',
  'pages_dashboard_before_month_total_used_amount.title.AM': '전월 총 매출',
  'pages_dashboard_before_month_total_used_amount.before_rate': '전전월 대비 증감률',
  'pages_dashboard_before_month_total_used_amount.before_amount': '전전월 대비 증감 금액',

  'pages_dashboard_select_top.button': '적용',
  'pages_dashboard_select_top.select_all': '전체 선택',

  'pages_dashboard_contract_cost_last_month.title': '계약별 전월 비용 Top3',
  'pages_dashboard_contract_cost_last_month.title.AM': '계약별 매출 Top3',
  'pages_dashboard_contract_cost_last_month.count': '계약 건수',
  'pages_dashboard_contract_cost_last_month.currency': '',

  'pages_dashboard_product_cost_last_month.title': '사용 상품 목록 및 전월 비용 Top3',
  'pages_dashboard_product_cost_last_month.title.AM': ' 상품별 매출 Top3',
  'pages_dashboard_product_cost_last_month.count': '사용 상품수',
  'pages_dashboard_product_cost_last_month.currency': '',

  'pages_dashboard_total_cost_preview_month.title': '전월 총 사용 비용',
  'pages_dashboard_total_cost_preview_month.title.AM': '전월 총 매출',
  'pages_dashboard_total_cost_preview_month.rate': '전월 대비 증감률',
  'pages_dashboard_total_cost_preview_month.amount': '전월 대비 증감 금액',
  'pages_dashboard_total_cost_preview_month.before_month': '전전월',
  'pages_dashboard_total_cost_preview_month.this_month': '전월',
  'pages_dashboard_total_cost_preview_month.currency': '',

  'pages_dashboard_product_used_cost.title': '상품별 사용 비용 (부가세 미포함)',
  'pages_dashboard_product_used_cost.title.AM': ' 상품별 매출 추이 (부가세 미포함)',
  'pages_dashboard_usage_cost_payment_status.title': '사용 비용 및 납부 현황',
  'pages_dashboard_usage_cost_payment_status.title.AM': '매출 및 납부 추이',

  'pages_dashboard_notice.header': '공지 사항',
  'pages_dashboard_notice.title': '제목',
  'pages_dashboard_notice.creatorId': '아이디',
  'pages_dashboard_notice.created': '등록일시',
  'pages_dashboard_notice.show_all_button': '전체 보기',

  'pages_dashboard_product_chart.tooltip': '사용 상품별 비용 현황이 차트로 표시됩니다.<br /> (부가세 미포함 금액입니다.)',
  'pages_dashboard_bill_chart.tooltip': '총 사용 비용 및 납부 현황이 차트로 표시됩니다.',
  'pages_dashboard_before_month_amount.tooltip': '전월 총 사용 비용이 표시됩니다.',
  'pages_dashboard_product_top3.tooltip': '사용 상품별 전월 비용이 표시됩니다.<br /> 비용이 높은 순으로 3개까지 표시됩니다.',
  'pages_dashboard_contract_top3.tooltip': '계약별 전월 비용이 표시됩니다.<br /> 비용이 높은 순으로 3개까지 표시됩니다.',


  'pages_dashboard_servicerequest.header': '문의 및 서비스 요청',
  'pages_dashboard_servicerequest.header.AM': '고객 문의',
  'pages_dashboard_servicerequest.receiveDate': '접수일시',
  'pages_dashboard_servicerequest.subject': '제목',
  'pages_dashboard_servicerequest.division': '상태',
}

export default Home




// WEBPACK FOOTER //
// ./src/lang/home/Home.kr.js